<template>
  <section class="relative text-gray-800 border rounded hover:shadow">
    <div class="flex items-center justify-between px-4 py-2 bg-gray-200 border-b rounded-t group">
      <h4 class="font-semibold">
        {{ $t('components.materialTemplate.title') }}
      </h4>

      <div>
        <button
          v-if="landingpageTemplateId"
          :title="$t('components.materialTemplate.generateAll')"
          class="mr-8 btn-inline-small"
          @click="generateMaterialsForTemplate()"
        >
          <fa
            :icon="faGear"
            fixed-width
          />
          {{ $t('components.materialTemplate.generateAll') }}
        </button>

        <button
          v-if="landingpageTemplateId"
          :title="$t('components.materialTemplate.create')"
          class="btn-inline-small"
          @click="showCreateModal()"
        >
          <fa
            :icon="faPlus"
            fixed-width
          />
          {{ $t('components.materialTemplate.create') }}
        </button>
      </div>
    </div>

    <div
      v-if="hasNoMaterialTemplates"
      class="p-4 text-gray-500"
    >
      <em>{{ $t('components.materialTemplate.noMaterials') }}</em>
    </div>

    <ul
      v-else
      class="py-2"
    >
      <template v-if="downloadMaterials.length">
        <li class="pl-4 mt-2 text-xs text-gray-600 uppercase">
          {{ $t('components.materialTemplate.downloads') }}
        </li>
        <MaterialTemplateListItem
          v-for="materialTemplate in downloadMaterials"
          :key="materialTemplate.id"
          v-bind="materialTemplate"
          @deleted="handleMaterialDeleted"
        />
      </template>

      <template v-if="basicAdMaterials.length">
        <li class="pl-4 mt-2 text-xs text-gray-600 uppercase">
          {{ $t('components.materialTemplate.basicAds') }}
        </li>
        <MaterialTemplateListItem
          v-for="materialTemplate in basicAdMaterials"
          :key="materialTemplate.id"
          v-bind="materialTemplate"
          @deleted="handleMaterialDeleted"
        />
      </template>

      <template v-if="campaignId && campaignMaterials.length">
        <MaterialTemplateListItem
          v-for="materialTemplate in campaignMaterials"
          :key="materialTemplate.id"
          v-bind="materialTemplate"
          @deleted="handleMaterialDeleted"
        />
      </template>
    </ul>
  </section>
</template>

<script>
import { faPlus, faGear } from '@fortawesome/free-solid-svg-icons'
import MaterialTemplateListItem from './list-item.vue'
import CreateModal from './create-modal'
import GENERATE from '@/graphql/GenerateMaterialsForTemplate.gql'

export default {
  components: { MaterialTemplateListItem },

  props: {
    landingpageTemplateId: {
      type: String,
      default: null
    },
    campaignId: {
      type: String,
      default: null
    },
    materialTemplates: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      faPlus,
      faGear
    }
  },

  computed: {
    downloadMaterials () {
      return this.materialTemplates.filter(({ type }) => type === 'DOWNLOAD')
    },

    basicAdMaterials () {
      return this.materialTemplates.filter(({ type }) => type === 'BASIC_AD')
    },

    campaignMaterials () {
      return this.materialTemplates.filter(({ type }) => type === 'CAMPAIGN')
    },

    hasNoMaterialTemplates () {
      return this.materialTemplates.length === 0
    }
  },

  methods: {
    showCreateModal () {
      this.$modal.show(CreateModal, {
        campaignId: this.campaignId,
        landingpageTemplateId: this.landingpageTemplateId
      })
    },

    handleMaterialDeleted (result) {
      this.$emit('material-deleted', result)
    },

    async generateMaterialsForTemplate () {
      const hasConfirmed = confirm(this.$t('components.materialTemplate.generateAllConfirm'))

      if (hasConfirmed) {
        try {
          const { data: { result } } = await this.$apollo.mutate({
            mutation: GENERATE,
            variables: {
              input: { landingpageTemplateId: this.landingpageTemplateId }
            }
          })
          alert(this.$t('components.materialTemplate.generateAllSuccess', { count: result }))
        } catch (err) {
          alert(this.$t('components.materialTemplate.generateAllFailed', { error: err.message }))
        }
      }
    }
  }
}
</script>
